import Vue from "vue";
import Vuex from "vuex";
import login from "../store/modules/login/login";
import register from "../store/modules/register/register";
import faq from "../store/modules/faq/faq";
import contact from "../store/modules/contact/contact";
import home from "../store/modules/home/home";
import social from "../store/modules/social/social";
import property from "../store/modules/dtl/property";
import price from "../store/modules/dtl/price";
import account from "../store/modules/account/account";
import purchase from "../store/modules/account/purchase";
import book from "../store/modules/account/book";
import reserve from "../store/modules/account/reserve";
import construction from "../store/modules/account/construction";
import recommend from "../store/modules/account/recommend";
import pia from "../store/modules/dtl/pia";
import invoice from "../store/modules/account/invoice";
import blog from "./modules/blog/blog";
import request from "./modules/request/request";
import common from "./modules/common";
import revealPriceList from "./modules/revealPriceList/revealPriceList";
import uConnect from "./modules/uConnect/uConnect";
Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    login,
    register,
    faq,
    contact,
    social,
    home,
    property,
    price,
    account,
    purchase,
    book,
    reserve,
    construction,
    recommend,
    pia,
    invoice,
    blog,
    request,
    revealPriceList,
    common,
    uConnect
  }
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js